<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
          ></div>
          <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              class="kh-font"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'acps_name_foreign'
        }"
      >
        <template v-slot="{ record }">
          <td>{{ record.start_date }}</td>
          <td>{{ record.end_date }}</td>
          <td>{{ record.announcement_criteria }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  props: ['fetch'],
  name: 'payment-announcement-table',
  data() {
    return {
      loading: false,
      columns: [
        { name: this.$t('paymentannouncement.startDate') },
        { name: this.$t('paymentannouncement.endDate') },
        { name: this.$t('paymentannouncement.criteria') },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('paymentAnnouncement', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.paymentAnnouncement.search
      },
      set(newValue) {
        this.$store.commit('paymentAnnouncement/SET_SEARCH', newValue)
        this.$store.commit('paymentAnnouncement/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('paymentAnnouncement/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('paymentAnnouncement/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'payment-announcement-edit',
        params: { id: record.anc_id }
      })
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('paymentAnnouncement/destroy', record.anc_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),

    fetch: function() {
      this.fetchData()
      this.$emit('fetched')
    }
  }
}
</script>
